
// ==========================
// Custom Image Slider (Swiper)
// ==========================
function useCaseCardTwo() {
  let use_case_card_two = new Swiper(`.custom-slider-section .customSlider`, {
    slidesPerView: 1.3,
    spaceBetween: 10,
    speed: 450,
    loop: true,
    loopAdditionalSlides: 3,
    centeredSlides: true,
    preventClicks: false,
    preventClicksPropagation: false,
    effect: "coverflow",
    coverflowEffect: {
      rotate: 0,
      stretch: -1,
      depth: 100,
      modifier: 2.4,
      slideShadows: false,
    },
    followFinger: true,
    allowTouchMove: true,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 2,
    },
    navigation: {
      nextEl: `.swiper-button-next`,
      prevEl: `.swiper-button-prev`,
    },
    scrollbar: {
      el: `.swiper-scrollbar`,
      draggable: true,
      snapOnRelease: false,
    },
    pagination: {
      el: `.swiper-pagination`,
      clickable: true,
      dynamicBullets: false,
      dynamicMainBullets: 4,
    },
    breakpoints: {
      100: {
        coverflowEffect: {
          rotate: 0,
          stretch: 8,
          depth: 90,
          modifier: 2,
          slideShadows: false,
        },
      },
      700: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
    },
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", useCaseCardTwo, { once: true });
} else {
  useCaseCardTwo();
}




// Product-page-zoom-js

document.addEventListener("DOMContentLoaded", function () {
  const zoomWindow = document.querySelector(".zoom-window");
  // zoom logic for any image
  function addZoomFunction(img) {
    img.addEventListener("mousemove", function (e) {
      zoomWindow.style.display = "block";
      zoomWindow.style.backgroundImage = `url(${img.src})`;
      let rect = img.getBoundingClientRect();
      let x = ((e.clientX - rect.left) / img.width) * 100;
      let y = ((e.clientY - rect.top) / img.height) * 100;
      zoomWindow.style.backgroundPosition = `${x}% ${y}%`;
    });
    img.addEventListener("mouseleave", function () {
      zoomWindow.style.display = "none";
    });
  }
  // apply zoom on all current images
  function initZoom() {
    const imgs = document.querySelectorAll(".product__media img");
    imgs.forEach(img => addZoomFunction(img));
  }
  // Run initially
  initZoom();
  // Re-run zoom after ANY image change
  document.addEventListener("click", function () {
    setTimeout(initZoom, 250);
  });
});


// logo-underline


